import React from "react";
import * as animationData from "./Speaker_Lottie.json";
import "./Speaker_Lottie.css";
import Lottie from "react-lottie";

export const Speaker_Lottie = () => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section className="main">
      <div className="speaker_div">
        <Lottie
          className="me-auto"
          options={defaultOptions}
          isClickToPauseDisabled={true}
          speed={1.5}
        />
      </div>
    </section>
  );
};
